module.exports = __webpack_public_path__ + "static/img/CA.de305d09.jpg";